module.exports = __webpack_public_path__ + "static/media/plus.95520ba3.svg";